import React from 'react'
import Branding from './Branding'
import PageSection from './PageSection'
import Compliance from './Compliance'
import { PiUsersFourFill } from "react-icons/pi";
import { FaDraftingCompass,FaCalendarAlt } from "react-icons/fa";
import { FaRegCircleQuestion } from "react-icons/fa6";

import { SiPowerpages } from "react-icons/si";
import { MdLocalPlay } from "react-icons/md";
import Booking from './Booking'
import Footer from './Footer'
import { FaStore } from "react-icons/fa";
import Clients from './Clients'
import { FaUserCircle } from "react-icons/fa";
import { SiAdguard } from "react-icons/si";
import { BsFillBookmarkStarFill } from "react-icons/bs";

import fs from '../../GMBImage/firstsection.png';
import sm from '../../GMBImage/mybusiness.jpg'
import cs from '../../GMBImage/chatsegmentation.jpeg'

import bs from '../../GMBImage/Businessquestion.jpeg'

import ca from '../../GMBImage/competitoranalysis.png'

import l from '../../GMBImage/localization.png'
import listing from '../../GMBImage/listing.png'
import bk from '../../GMBImage/Bookings.png'
import { useNavigate } from 'react-router-dom';





function GMB() {
  const navigate = useNavigate();
  const storeManagementData = [{

    icon:<FaStore />,
    iconTitle: 'Store Management',
    image: sm,
    title: 'Streamline the management of your physical and online stores. Ensure consistency and accuracy across all locations.',
    lines: [
      'Centralized control for product listings, inventory, and pricing.',
      'Sync online and offline store data for a unified experience.',
      'Manage multiple store locations seamlessly.'
    ],
  }];

  const chatSegmentationData = [{
    icon:<PiUsersFourFill />,
    iconTitle: 'Chat Segmentation',
    image: cs,

    title: 'Enhance communication by organizing and prioritizing customer inquiries. Respond promptly and provide a personalized experience.',
    lines: [
      'Automated chat segmentation based on customer queries.',
      'Prioritize high-priority conversations for quick resolution.',
      'Integrate with popular messaging platforms for seamless communication.'
    ],
  }];

  const businessQuestionsData = [{
    icon:<FaRegCircleQuestion />,
    iconTitle: 'Business Questions',
    image: bs,

    title: 'Respond intelligently to customer inquiries and provide accurate information. Build trust and loyalty with informative responses.',
    lines: [
      'AI-powered responses to common business-related questions.',
      'Access a knowledge base for quick reference and accurate answers.',
      'Improve customer satisfaction with timely and helpful responses.'
    ],
  }];
  

  const competitorAnalysisData = [{
    icon:<FaDraftingCompass />,
    iconTitle: 'Competitor Analysis',
    image: ca,

    title: 'Gain insights into your competitors and market trends. Leverage data to refine your strategies and stay ahead in your industry.',
    lines: [
      'Monitor competitor reviews and customer feedback.',
      'Analyze market trends and adjust your offerings accordingly.',
      'Identify competitive advantages and areas for improvement.'
    ],
  }];
  
  const localizationData = [{
    icon:<MdLocalPlay />,
    iconTitle: 'Localization',
    image: l,

    title: 'Customize your business strategies to cater to the unique needs and preferences of different regions. Enhance your global presence.',
    lines: [
      'Localized content and marketing strategies for targeted regions.',
      'Adapt product offerings based on regional preferences.',
      'Optimize business listings and profiles for local search.'
    ],
  }];
  
  const businessProfileListingsData = [{
    icon:<SiPowerpages />,
    iconTitle: 'Business Profile / Listings',
    image: listing,

    title: 'Maintain consistent and engaging business profiles and listings across various online platforms. Maximize visibility and credibility.',
    lines: [
      'Manage and update business information on Google My Business.',
      'Optimize profiles on other platforms for maximum exposure.',
      'Enhance brand visibility with compelling business descriptions and visuals.'
    ],
  }];
  const bookingsData = [{
    icon:<FaCalendarAlt className='text-base' />,
    iconTitle: 'Bookings',
    image: bk,

    title: 'Simplify the appointment and booking process for your business. Provide customers with a seamless experience from scheduling to confirmation.',
    lines: [
      'Integrated booking system with real-time availability.',
      'Automated appointment reminders for customers.',
      'Customizable booking options to suit your business needs.'
    ],
  }];

  
  const reviewCard = [{
    icon:<FaUserCircle />,
    title: 'Retain Potential Customers',
    sub: 'Harness the power of GMB  to retain potential customers. Professionally addressing feedback on your GMB profile not only prevents customer loss but also attracts new patrons, bolstering your brand reputation.',

},
{
    icon:<SiAdguard />,
    title: 'Trust Building on GMB',
    sub: 'GMB is a trusted platform for customer insights. Positive GMB reviews serve as compelling social proof, instilling trust and confidence in your brand, products, and services.',

},
{
    icon:<BsFillBookmarkStarFill />,
    title: 'Manage Business Listings',
    sub: "Monitoring and managing online business profile allow customers to interact on multiple channels. Addressing negative reviews professionally can help mitigate the impact on the brand's reputation.",

},]

  
  return (
    <div className='pt-5  gap-[70px] flex flex-col items-center min-h-full w-full'>
    <div className='w-full flex justify-center bg-white sticky top-0 pt-5'>
        <div   className={` w-[78%]   flex  bg-white  pb-4 `}>    
            <div className='flex gap-2 items-center'>
                <div>
                <FaStore className='text-[30px] text-blue-600' />
                </div>
                <div className='flex flex-col'>
                    <span className='semibold text-[13px]'>Elyzian</span>
                    <span className='bold text-sm'>Business Management</span>

                </div>
            </div>
        </div>
  </div>

  {/* 1st Section */}

  <div   className="w-full sm:w-[90%] lg:w-[85%] 2xl:w-[78%] h-max lg:h-[620px] sm:mt-3  flex flex-col lg:flex-row gap-6 lg:gap-3   p-[5%] bg-[#fafafa] sm:rounded-[50px]">       
     <div className='w-full lg:w-[50%] flex flex-col gap-5 justify-start h-full'>
        <div>     
        <span className='bold text-[28px] lg:text-[32px] xl:text-[38px] 2xl:text-[44px]   sm:leading-[45px] xl:leading-[55px] 2xl:leading-[65px]'>Optimized Stores,<br />Elevated Success</span>    
</div>
       
        <span className='regular  text-sm sm:text-base lg:text-[18px] 2xl:text-[20px] leading-[26px] lg:leading-[36px]  '> Seamlessly integrate your physical and online stores to enhance efficiency, boost customer satisfaction, and make informed decisions. Harness the power of centralized control, real-time analytics, and streamlined operations to drive revenue growth and ensure long-term success.
        </span>
        
            
            <button onClick={() => navigate('/waitlist')}  className="flex items-center gap-2 text-sm w-max  sm:text-[14px]  tracking-wide rounded-lg hover:shadow hover:bg-[#1e46f6f6] hover:ring-[2px] hover:ring-blue-200 bold px-3 py-2 sm:px-5 border sm:p-[12px] bg-[#1e47f6] border-[#1e47f6] text-white hover:transition hover:delay-200">
<span className="button-content medium">Get Started Free</span>
</button>
     </div>
     <div className=' w-full lg:w-[50%]'>
     <img className=' aspect-auto' src={fs} alt="" />
     </div>
  </div>

  {/* 2nd Section */}
        <Clients />

        {/* 3rd Section */}
        <div  className="w-[90%] lg:w-[85%] 2xl:w-[78%] flex flex-col gap-10 mt-24 items-center">       
<span className='bold text-center  text-[20px] sm:text-[24px] lg:text-[30px]'>Why does business management matter?</span>
<div className=' flex flex-wrap xl:flex-nowrap gap-4 justify-evenly w-full'>
 {reviewCard?.map((e) => (
    <div className="w-[380px] h-[400px] border rounded-[30px] shadow-md bg-[#fafafa] flex flex-col gap-5 p-6">
    <span className="text-2xl xl:text-3xl 2xl:text-5xl text-blue-700"> {e.icon}</span>
    <span className='bold text-[17px] xl:text-[20px]  '>{e.title}</span>    
        
         <span className='regular text-sm lg:text-base leading-[25px] lg:leading-[30px] break-words  '>{e.sub}</span>
    </div>
 ))}
   

</div>
</div>
  {/* 4th Section */}
  <PageSection bg  data={storeManagementData} />

  <PageSection reverse  data={chatSegmentationData} />
  {/* <Clients /> */}


  <PageSection   data={businessQuestionsData} />

  <PageSection bg  data={competitorAnalysisData} />

  <PageSection reverse  data={localizationData} />

  <PageSection bg data={businessProfileListingsData} />


  <Branding />

  <PageSection bg reverse data={bookingsData} />

  <Compliance />

  <Booking />

  <Footer />






</div>
  )
}

export default GMB
